var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.652,
    height: 34.653,
    viewBox: "0 0 34.652 34.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location_Connect_",
    "data-name": "Location(Connect)",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M34.657,24.365c0-4.563-4.585-7.6-8.888-9.009a12.786,12.786,0,0,0,1.44-5.478,9.878,9.878,0,1,0-19.757,0,12.786,12.786,0,0,0,1.44,5.478C-1.291,18.683-3.048,27.078,5.311,31.816c5.96,3.377,14.973,3.7,21.494,1.192a3.247,3.247,0,0,0,5.449-3.361,7.463,7.463,0,0,0,2.4-5.281ZM17.331,2.166a7.721,7.721,0,0,1,7.713,7.713c0,4.5-4.488,9.879-7.713,13-3.227-3.122-7.712-8.5-7.712-13a7.721,7.721,0,0,1,7.713-7.713Zm-3.8,24.626a3.251,3.251,0,0,0-5.333-2.2.5.5,0,0,1-.068-.229c0-.573,1.57-1.824,5.318-2.414a39.067,39.067,0,0,0,3.17,3.226,1.083,1.083,0,0,0,1.433,0,39.1,39.1,0,0,0,3.17-3.226c3.748.59,5.318,1.841,5.318,2.414,0,.392-.721,1.081-2.3,1.664A23.607,23.607,0,0,1,13.528,26.792Zm-3.236-.8A1.083,1.083,0,1,1,9.21,27.072,1.084,1.084,0,0,1,10.292,25.989ZM6.379,29.931c-7.2-4.081-4.613-10.145,3.577-12.64a30.807,30.807,0,0,0,1.91,2.752c-2.459.536-5.905,1.807-5.905,4.322A2.981,2.981,0,0,0,7.078,26.6a3.248,3.248,0,0,0,5.9,2.3c6.709,1.1,15.723-.507,15.723-4.533,0-2.515-3.445-3.786-5.905-4.322a30.806,30.806,0,0,0,1.91-2.752c4.757,1.449,7.785,4.176,7.785,7.074a5.365,5.365,0,0,1-1.677,3.655A3.251,3.251,0,0,0,26,31c-5.859,2.239-14.189,2.012-19.618-1.064Zm22.864,2.014a1.083,1.083,0,1,1,1.083-1.083A1.084,1.084,0,0,1,29.243,31.945Z",
    fill: "#ff1c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M181.421,74.829a5.414,5.414,0,1,0-5.414-5.414A5.421,5.421,0,0,0,181.421,74.829Zm0-8.663a3.249,3.249,0,1,1-3.249,3.249A3.252,3.252,0,0,1,181.421,66.166Z",
    transform: "translate(-164.09 -59.668)",
    fill: "#ff1c51"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoca);
export default __webpack_public_path__ + "static/media/loca.3dee4185bbfaddda405ac70801e2cab1.svg";
export { ForwardRef as ReactComponent };